<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M3210.25 1093.63l-2822.25 0 0 -352.8 2822.25 0 0 352.8zm0 1763.86l-2822.25 0 0 -1058.33 2822.25 0 0 1058.33zm0 -2469.46l-2822.25 0c-195.8,0 -352.73,157 -352.73,352.8l0 2116.66c0,194.73 158,352.73 352.8,352.73l2822.18 0.07c194.8,-0.07 352.8,-158.07 352.8,-352.87l-0.07 -2116.59c0,-195.8 -158.73,-352.8 -352.73,-352.8z"/>
  </g>
 </g>
</svg>
